var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChartYAxis = function SvgChartYAxis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h48v48H0z",
    "data-name": "invisible box"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6 13.2a2.1 2.1 0 0 0-.2-2.7l-6-5.9a1.9 1.9 0 0 0-2.8 0l-6 5.9a2.1 2.1 0 0 0-.2 2.7 1.9 1.9 0 0 0 3 .2l2.6-2.6V42a2 2 0 0 0 4 0V10.8l2.6 2.6a1.9 1.9 0 0 0 3-.2ZM22 40h-2a2 2 0 0 0 0 4h2a2 2 0 0 0 0-4ZM32 40h-2a2 2 0 0 0 0 4h2a2 2 0 0 0 0-4ZM42 40h-2a2 2 0 0 0 0 4h2a2 2 0 0 0 0-4Z"
  })))));
};
export default SvgChartYAxis;